/**
 * Gen1 Dual relay device templates
 * Used by: SHSW-21 (Shelly 2), SHSW-25 (Shelly 2.5), SHUNI-1 (Shelly UNI)
 *
 * Gen1 devices use HTTP endpoints instead of RPC
 */

import {
	createGen1TurnAction,
	createGen1StateCondition,
	createGen1StateChangedTrigger,
} from './stateManagement.js';
import { createGen1PowerLevelCondition, createGen1PowerThresholdTrigger } from './powerMonitoring.js';

/**
 * Dual relay without power monitoring
 */
export function createGen1DualRelayTemplate() {
	return {
		deviceType: 'gen1_dual_relay',
		generation: 1,
		channels: ['relay:0', 'relay:1'],
		actions: {
			turn: createGen1TurnAction('relay', false),
		},
		conditions: {
			isOn: createGen1StateCondition('relay'),
		},
		triggers: {
			stateChanged: createGen1StateChangedTrigger('relay'),
		},
	};
}

/**
 * Dual relay with power monitoring
 */
export function createGen1DualRelayPMTemplate(maxPowerPerChannel = 1840) {
	return {
		deviceType: 'gen1_dual_relay_pm',
		generation: 1,
		channels: ['relay:0', 'relay:1'],
		actions: {
			turn: createGen1TurnAction('relay', true),
		},
		conditions: {
			isOn: createGen1StateCondition('relay'),
			powerLevel: createGen1PowerLevelCondition(maxPowerPerChannel),
		},
		triggers: {
			stateChanged: createGen1StateChangedTrigger('relay'),
			powerThreshold: createGen1PowerThresholdTrigger(maxPowerPerChannel),
		},
	};
}
